var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildTestUrl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 44q-1.2 0-2.1-.9Q8 42.2 8 41V7q0-1.2.9-2.1Q9.8 4 11 4h18.05L40 14.95V41q0 1.2-.9 2.1-.9.9-2.1.9Zm0-3h26V16.3h-9.3V7H11v34Zm13-4q2.95 0 4.975-2.05Q31 32.9 31 30v-7h-2v7q0 2.1-1.425 3.55Q26.15 35 24 35q-2.1 0-3.55-1.45Q19 32.1 19 30V19q0-.9.575-1.45Q20.15 17 21 17q.9 0 1.45.55.55.55.55 1.45v10h2V19q0-1.7-1.15-2.85Q22.7 15 21 15q-1.65 0-2.825 1.15Q17 17.3 17 19v11q0 2.9 2.05 4.95Q21.1 37 24 37ZM11 7v9.3V7v34V7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildTestUrl);
export default __webpack_public_path__ + "static/media/build-test-url.616d2f4553db87520dc7810ad157c1c2.svg";
export { ForwardRef as ReactComponent };